import { useEffect, useState } from "react";
import { Box, CircularProgress } from "@mui/material";
import { useAppDispatch } from "../../Redux/hooks";
import { setRole } from "../../Redux/reducers/userSlice";
import { resetState } from "../../Redux/actions/resetAction";
import { store } from "../../Redux/store";
import http from "../../utils/http";
import { toastMessage } from "../../utils/toast";

type SessionLoaderProps = {
  children: React.ReactNode;
};

export function SessionLoader({ children }: SessionLoaderProps) {
  const dispatch = useAppDispatch();
  const [sessionReady, setSessionReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("cadence-access-token");
    if (!token) {
      setSessionReady(true);
      return;
    }
    const loadSessionRole = async () => {
      try {
        const res = await http.get("/auth/me");
        const data = res.data?.data ?? res.data;
        dispatch(setRole(data?.role ?? ""));
      } catch {
        // 498 handled by http interceptor; other errors handled in finally
      } finally {
        const currentRole = store.getState().user.role;
        if (!currentRole) {
          toastMessage("error", "Session expired");
          console.error("Role not found");
          localStorage.clear();
          dispatch(resetState());
        }
        setSessionReady(true);
      }
    };
    loadSessionRole();
  }, [dispatch]);

  if (!sessionReady) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return <>{children}</>;
}
